import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Conditional className helper. Merges Tailwind classes intelligently. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
